/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/**
 * Value of a boolean device feature requirement, expressed as the string "true" or "false".
 */
export enum DeviceFeatureBoolean {
  DeviceFeatureBooleanTrue = 'true',
  DeviceFeatureBooleanFalse = 'false',
}
